import React from 'react'
import CardHeader from '@material-ui/core/CardHeader'
import PropType from 'prop-types'

const Header = ({
  title, action, textColor, className,
}) => (
  <CardHeader className={className} style={{ color: textColor }} title={title} action={action} />
)

Header.defaultProps = {
  action: null,
  className: '',
  textColor: '#000',
  title: '',
}

Header.propTypes = {
  action: PropType.element,
  className: PropType.string,
  textColor: PropType.string,
  title: PropType.node,
}

export default Header
